// TanStack Query client + defaults.
// Source : PRD 09 §3 state management.
//
// Defaults :
// - staleTime 30s : emails/notes/tasks ne changent pas brutalement, 30s de
//   cache évite le refetch inutile au mount répété de composants. Les endpoints
//   critiques (profile, subscription) peuvent override via `useQuery({staleTime:0})`.
// - retry 1 : un seul retry pour éviter d'attendre trop longtemps sur un
//   endpoint cassé. Le UI affiche l'erreur plus vite.
// - refetchOnWindowFocus false : évite le flash de revalidation au tab-switch
//   (mauvais UX en dev avec hot reload).
import { QueryClient } from "@tanstack/react-query";

export function createQueryClient(): QueryClient {
  return new QueryClient({
    defaultOptions: {
      queries: {
        staleTime: 30_000,
        retry: 1,
        refetchOnWindowFocus: false,
      },
      mutations: {
        retry: 0,
      },
    },
  });
}
